import React from 'react';

function MedicationList({ medications }) {
  if (!medications || medications.length === 0) {
    return (
      <div className="med-list">
        <div className="med-empty">No specific discharge medications identified for this diagnosis.</div>
      </div>
    );
  }

  return (
    <div className="med-list">
      <div className="med-count">{medications.length} Discharge Medications</div>
      <div className="med-table">
        <div className="med-table-header">
          <span className="med-col-name">Medication</span>
          <span className="med-col-dose">Dose</span>
          <span className="med-col-duration">Duration</span>
          <span className="med-col-reason">Reason</span>
        </div>
        {medications.map((med, i) => (
          <div key={i} className="med-table-row">
            <span className="med-col-name">{med.name}</span>
            <span className="med-col-dose">{med.dose}</span>
            <span className="med-col-duration">{med.duration}</span>
            <span className="med-col-reason">{med.reason}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MedicationList;
